package com.milta.core.localization.translations.pl

import com.milta.core.localization.WebHistoriqueStrings

internal val WebHistorique = WebHistoriqueStrings(
    screenATitle = "Historia tras",
    periodLabel = "Okres",
    periodLastEightDays = "Ostatnie 8 dni",
    periodSingleDate = "Konkretna data",
    periodRange = "Zakres dat",
    rangeFromLabel = "Od",
    rangeToLabel = "Do",
    driverFilterLabel = "Kierowca",
    driverFilterAllOption = "Wszyscy kierowcy",
    historySearchLabel = "Szukaj",
    historySearchPlaceholder = "Szukaj kierowcy, odbiorcy, adresu, powodu…",
    columnDate = "Data",
    columnDriver = "Kierowca",
    columnTotalDeliveries = "Łącznie dostaw",
    columnDelivered = "Dostarczone",
    columnFailed = "Nieudane",
    viewProofsAction = "Zobacz potwierdzenia",
    emptyHistoryMessage = "Nie znaleziono żadnej trasy dla tego okresu.",
    errorInvalidPeriod = "Wybrany okres jest nieprawidłowy.",
    screenBTitle = "Historia potwierdzeń dostawy",
    routeOfLabel = "Trasa z dnia",
    totalDeliveriesLabel = "dostaw",
    deliveredLabel = "dostarczonych",
    failedLabel = "nieudanych",
    backToHistoryAction = "Historia tras",
    statusDeliveredBadge = "Dostarczono",
    statusFailedBadge = "Nieudane",
    viewReasonAction = "Zobacz powód",
    hideReasonAction = "Ukryj powód",
    photoPlaceholderAlt = "Brak dostępnego zdjęcia",
    photoAlt = "Potwierdzenie dostawy",
    emptyProofsMessage = "Brak potwierdzeń dostawy dla tej trasy.",
    proofsSearchLabel = "Szukaj dostawy",
    proofsSearchPlaceholder = "Szukaj odbiorcy, adresu, powodu…",
    paginationPrevious = "Poprzednia",
    paginationNext = "Następna",
)
